import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { PlacementFrontend } from '@post-office/browser--jsm-sequoia/jsm-issue-view-details-section';

import { type PlacementRenderProps } from '@post-office/browser--jsm-sequoia/jsm-issue-view-details-section';

import type { MessageTemplateContext } from '../../..';

import { Banner } from '../../../components/banner/Banner';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type MessageFrontendProps = MessageTemplateContext & PlacementRenderProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageFrontendProps>(),
		Component: ({
			cloudId,
			edition,
			dismiss,
			shouldRenderIncidentsPremiumTrialNudge,
		}: MessageFrontendProps) => (
			<Banner
				cloudId={cloudId}
				edition={edition}
				dismiss={dismiss}
				shouldRenderIncidentsPremiumTrialNudge={shouldRenderIncidentsPremiumTrialNudge}
			/>
		),
	},
});
